module.exports = __webpack_public_path__ + "static/img/product_banner_06_zh.5a20897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_06_zh.png
// module id = PmbB
// module chunks = 34